import * as React from 'react';
import {
    Create,
    TextInput,
    required,
    SimpleForm,
    DateInput,
    SelectInput,
    ReferenceInput,
    NumberInput,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';

const ChapterCreate = () => {
    let { programId, subjectId } = useParams();
    if (!subjectId) {
        return <LoadingSection />;
    }
    return (
        <Create
            redirect={() => {
                return `programs/${programId}/subjects/${subjectId}/chapters`;
            }}
            resource={'chapters'}
        >
            <SimpleForm defaultValues={{ programId: programId, subjectId: subjectId }}>
                <FileUpload type="VIDEO_THUMBNAIL" source="image" accept={'image/*'} />
                <TextInput source="name" fullWidth validate={[required()]} />
                <SlugInput source="slug" fullWidth />
                <NumberInput source="displayOrder" type={'number'} fullWidth />
                <HTMLEditorInput
                    source={'description'}
                    fullWidth
                    validate={[required(), validHtml]}
                />
            </SimpleForm>
        </Create>
    );
};

export default ChapterCreate;
